/* Winkel op de homepage, de plankenpagina en de onderhoudspagina: tabbladen, uitvoering, maat of verpakking kiezen, olie erbij, direct in het mandje. */
(function () {
  // Meerdere secties op één pagina laden dit script; maar één keer starten, anders gaat alles dubbel in het mandje.
  if (window.__thewootzShopTabs) return;
  window.__thewootzShopTabs = true;
  // theme.js laadt na dit script: de helpers pas opzoeken als ze nodig zijn.
  var T = function () { return window.TheWootz || {}; };
  var money = function (c) { return T().money ? T().money(c) : (c / 100).toFixed(2).replace('.', ','); };

  document.querySelectorAll('[data-shop]').forEach(function (root) {
    var anchor = root.getAttribute('data-care-anchor');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-st-tab]'));

    function showTab(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-st-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus({ preventScroll: true });
      });
      root.querySelectorAll('[data-st-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-st-panel') !== key; });
    }

    function update(card) {
      var sel = card.querySelector('[data-st-variant][aria-checked="true"]');
      var price = parseInt((sel || card).getAttribute('data-price'), 10);
      var included = !!(sel && sel.getAttribute('data-care'));
      var addon = card.querySelector('[data-st-addon]');
      if (addon) {
        addon.hidden = included;
        if (!included && addon.getAttribute('aria-pressed') === 'true') price += parseInt(addon.getAttribute('data-price'), 10);
      }
      var inc = card.querySelector('[data-st-included]');
      if (inc) inc.hidden = !included;
      card.querySelector('[data-st-total]').textContent = money(price);
      // Onderhoudskaarten: losse prijs doorgestreept, besparing en een korte regel naast de prijs,
      // en de foto en link van de gekozen maat.
      var was = card.querySelector('[data-st-was]'), save = card.querySelector('[data-st-save]'), regel = card.querySelector('[data-st-regel]');
      function zet(el, attr) { if (!el) return; var t = (sel && sel.getAttribute(attr)) || ''; el.textContent = t; el.hidden = !t; }
      zet(was, 'data-was'); zet(save, 'data-save'); zet(regel, 'data-regel');
      var img = card.querySelector('[data-st-img]'), src = sel && sel.getAttribute('data-img'), url = sel && sel.getAttribute('data-url');
      if (img && src && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.src = src; }
      if (url) card.querySelectorAll('[data-st-link]').forEach(function (a) { a.href = url; });
    }

    function add(btn) {
      var card = btn.closest('[data-st-card]');
      var sel = card.querySelector('[data-st-variant][aria-checked="true"]');
      var id = parseInt(sel ? sel.getAttribute('data-st-variant') : card.getAttribute('data-variant'), 10);
      var items = [{ id: id, quantity: 1 }];
      if (sel && sel.getAttribute('data-selling-plan')) items[0].selling_plan = parseInt(sel.getAttribute('data-selling-plan'), 10);
      var addon = card.querySelector('[data-st-addon]');
      if (addon && !addon.hidden && addon.getAttribute('aria-pressed') === 'true') items.push({ id: parseInt(addon.getAttribute('data-st-addon'), 10), quantity: 1 });
      var err = card.querySelector('[data-st-error]');
      if (!T().addToCart) { window.location.href = '/cart/add?id=' + id + '&quantity=1'; return; }
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Even geduld';
      if (err) err.hidden = true;
      T().addToCart(items).then(function () {
        btn.textContent = 'Toegevoegd';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
      }).catch(function (e) {
        btn.textContent = label;
        btn.disabled = false;
        if (err) { err.textContent = e.message || ((window.T && window.T.add_failed_retry) || ''); err.hidden = false; }
      });
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-st-tab]');
      if (tab) { e.preventDefault(); showTab(tab.getAttribute('data-st-tab')); return; }

      var go = e.target.closest('[data-st-goto]');
      if (go) {
        showTab(go.getAttribute('data-st-goto'), true);
        var top = root.getBoundingClientRect().top;
        if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var opt = e.target.closest('[data-st-variant]');
      if (opt && !opt.disabled) {
        opt.parentElement.querySelectorAll('[data-st-variant]').forEach(function (b) { b.setAttribute('aria-checked', b === opt ? 'true' : 'false'); });
        update(opt.closest('[data-st-card]'));
        return;
      }

      // Het vinkje zelf wordt in theme.js omgezet (geldt voor elke .addon); daarna de prijs bijwerken.
      var addon = e.target.closest('[data-st-addon]');
      if (addon) { var card = addon.closest('[data-st-card]'); setTimeout(function () { update(card); }, 0); return; }

      var btn = e.target.closest('[data-st-add]');
      if (btn) add(btn);
    });

    // Pijltjestoetsen tussen de tabbladen en tussen de keuzes.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
      var dir = (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1;
      var tab = e.target.closest('[data-st-tab]');
      if (tab) {
        e.preventDefault();
        var next = tabs[(tabs.indexOf(tab) + dir + tabs.length) % tabs.length];
        showTab(next.getAttribute('data-st-tab'), true);
        return;
      }
      var opt = e.target.closest('[data-st-variant]');
      if (opt) {
        e.preventDefault();
        var group = Array.prototype.slice.call(opt.parentElement.querySelectorAll('[data-st-variant]:not([disabled])'));
        var n = group[(group.indexOf(opt) + dir + group.length) % group.length];
        n.click();
        n.focus();
      }
    });

    // Links naar het anker (hero, aankondiging, menu) openen tabblad 2.
    function fromHash() { if (anchor && window.location.hash === '#' + anchor) showTab('care'); }
    fromHash();
    window.addEventListener('hashchange', fromHash);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a || !anchor) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.hash === '#' + anchor && url.pathname === window.location.pathname) showTab('care');
    });

    // Staat er op een kaart met keuzeknoppen niets gekozen, kies dan de eerste.
    root.querySelectorAll('.st-sizes').forEach(function (g) {
      if (!g.querySelector('[aria-checked="true"]') && g.firstElementChild) g.firstElementChild.setAttribute('aria-checked', 'true');
    });

    // Terug via de browser (bfcache): prijzen weer gelijk trekken met de keuzes.
    window.addEventListener('pageshow', function () { root.querySelectorAll('[data-st-card]').forEach(update); });
  });
})();
